import { render, staticRenderFns } from "./DashboardTableEx.vue?vue&type=template&id=1c497ae0&shadow"
import script from "./DashboardTableEx.vue?vue&type=script&lang=js&shadow"
export * from "./DashboardTableEx.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports